import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { CurrencyRatesService } from '../../../services/currency-rates';

/**
 * Курсы USD / EUR / CNY к тенге с флагами — для верхней панели и меню кабинета.
 * Сами курсы загружает каркас (CurrencyRatesService.start), здесь только показываем.
 */
@Component({
  selector: 'app-currency-rates',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './currency-rates.component.html',
  styleUrl: './currency-rates.component.scss'
})
export class CurrencyRatesComponent implements OnInit, OnDestroy {
  /** light — на белой панели, dark — в тёмном боковом меню. */
  @Input() variant: 'light' | 'dark' = 'light';

  readonly codes = ['USD', 'EUR', 'CNY'];
  rates: Record<string, number> = {};
  private subscription?: Subscription;

  constructor(private currencyRates: CurrencyRatesService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscription = this.currencyRates.getRates().subscribe(r => {
      this.rates = { ...r };
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
